import { render, staticRenderFns } from "./EditBike.vue?vue&type=template&id=0cba6212&scoped=true"
import script from "./EditBike.vue?vue&type=script&lang=js"
export * from "./EditBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba6212",
  null
  
)

export default component.exports